import {
  Box,
  Typography,
  Paper,
  Collapse,
  IconButton,
} from "@material-ui/core";
import Axios from "axios";
import React, { useState, useCallback, useEffect, Fragment } from "react";
import Notify from "src/notification/Notify";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import HemathologyOrderDetails from "./details/HemathologyOrderDetails";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ListAltIcon from "@material-ui/icons/ListAlt";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import WarningIcon from "@material-ui/icons/Warning";
import { grey } from "@material-ui/core/colors";
import CBCOrderDetails from "./details/CBCOrderDetails";

const HemathologyOrder = ({ patient_id }) => {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");

  const [order, setOrder] = useState({
    data: [],
    ready: false,
  });

  const [orderCBC, setOrderCBC] = useState({
    data: [],
    ready: false,
  });

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedCBCOrder, setSelectedCBCOrder] = useState(null);

  const getLabHemaOrder = useCallback(() => {
    var formdata = new FormData();
    formdata.set("token", token);
    formdata.set("user_id", user_id);
    formdata.set("patient_id", patient_id);

    Axios.post("laboratory/order/ordernew-hemathology", formdata)
      .then((response) => {
        const data = response.data;
        setOrder({ data: data, ready: true });
      })
      .catch((error) => {
        Notify.requestError(error);
      });
  }, [token, user_id, patient_id]);

  const getLabCBCOrder = useCallback(() => {
    var formdata = new FormData();
    formdata.set("token", token);
    formdata.set("user_id", user_id);
    formdata.set("patient_id", patient_id);

    Axios.post("laboratory/order/ordernew-cbc", formdata)
      .then((response) => {
        const data = response.data;
        setOrderCBC({ data: data, ready: true });
      })
      .catch((error) => {
        Notify.requestError(error);
      });
  }, [token, user_id, patient_id]);

  const resetDisplay = () => {
    setSelectedOrder(null);
  };

  useEffect(() => {
    getLabHemaOrder();
    getLabCBCOrder();
  }, [getLabHemaOrder, getLabCBCOrder]);

  return (
    <>
      <Box my={1}>
        <Typography color="textSecondary" variant="h6">
          Hemathology Order
        </Typography>
      </Box>

      {order.ready ? (
        order.data.length > 0 ? (
          order.data.map((data, index) => {
            return (
              <Fragment key={index}>
                <Paper component={Box} my={2} p={2}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Box display="flex">
                        <Box mt={1} mr={2}>
                          {Boolean(parseInt(data.is_processed)) ? (
                            <QueryBuilderIcon
                              style={{ fontSize: "2rem" }}
                              color="primary"
                            />
                          ) : Boolean(parseInt(data.is_pending)) ? (
                            <WarningIcon
                              style={{ fontSize: "2rem" }}
                              color="secondary"
                            />
                          ) : (
                            <ListAltIcon
                              style={{ fontSize: "2rem", color: grey[500] }}
                            />
                          )}
                        </Box>

                        <Box>
                          <Box>
                            <Typography
                              variant="subtitle1"
                              className={`gtc-uppercase`}
                            >
                              {" "}
                              {Notify.dateTimeConvert(data.date_ordered)}{" "}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              className={`gtc-uppercase`}
                            >
                              {" "}
                              {data.trace_number}{" "}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <IconButton
                        color="primary"
                        onClick={() =>
                          setSelectedOrder(
                            selectedOrder &&
                              selectedOrder.trace_number === data.trace_number
                              ? null
                              : data
                          )
                        }
                      >
                        {selectedOrder &&
                        selectedOrder.trace_number === data.trace_number ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </IconButton>
                    </Box>
                  </Box>

                  <>
                    {" "}
                    {/* order result form */}
                    {selectedOrder && (
                      <Collapse
                        in={selectedOrder.trace_number === data.trace_number}
                      >
                        <Box mt={2}>
                          <HemathologyOrderDetails
                            order={selectedOrder}
                            getLabHemaOrder={getLabHemaOrder}
                            resetDisplay={resetDisplay}
                          />
                        </Box>
                      </Collapse>
                    )}
                  </>
                </Paper>
              </Fragment>
            );
          })
        ) : (
          <Box>{Notify.noRecord()}</Box>
        )
      ) : (
        <Box>{Notify.loading()}</Box>
      )}

      <Box my={1}>
        <Typography color="textSecondary" variant="h6">
          Hemathology CBC / CBC With Platelet Order
        </Typography>
      </Box>

      {/* cbc / cbc platelet */}
      {orderCBC.ready ? (
        orderCBC.data.length > 0 ? (
          orderCBC.data.map((data, index) => {
            return (
              <Fragment key={index}>
                <Paper component={Box} my={2} p={2}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Box display="flex">
                        <Box mt={1} mr={2}>
                          {Boolean(parseInt(data.is_processed)) ? (
                            <QueryBuilderIcon
                              style={{ fontSize: "2rem" }}
                              color="primary"
                            />
                          ) : Boolean(parseInt(data.is_pending)) ? (
                            <WarningIcon
                              style={{ fontSize: "2rem" }}
                              color="secondary"
                            />
                          ) : (
                            <ListAltIcon
                              style={{ fontSize: "2rem", color: grey[500] }}
                            />
                          )}
                        </Box>

                        <Box>
                          <Box>
                            <Typography
                              variant="subtitle1"
                              className={`gtc-uppercase`}
                            >
                              {Notify.dateTimeConvert(data.date_ordered)}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              className={`gtc-uppercase`}
                            >
                              {data.trace_number}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <IconButton
                        color="primary"
                        onClick={() =>
                          setSelectedCBCOrder(
                            selectedCBCOrder &&
                              selectedCBCOrder.trace_number ===
                                data.trace_number
                              ? null
                              : data
                          )
                        }
                      >
                        {selectedCBCOrder &&
                        selectedCBCOrder.trace_number === data.trace_number ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </IconButton>
                    </Box>
                  </Box>

                  <>
                    {/* order result form */}
                    {selectedCBCOrder && (
                      <Collapse
                        in={selectedCBCOrder.trace_number === data.trace_number}
                      >
                        <Box mt={2}>
                          <CBCOrderDetails
                            order={selectedCBCOrder}
                            getLabHemaOrder={getLabHemaOrder}
                            resetDisplay={resetDisplay}
                          />
                        </Box>
                      </Collapse>
                    )}
                  </>
                </Paper>
              </Fragment>
            );
          })
        ) : (
          <Box>
            <Typography color="secondary">
              No CBC / CBC With Platelet order found.
            </Typography>
          </Box>
        )
      ) : (
        <Box>
          <Typography color="primary"> Loading, please wait... </Typography>
        </Box>
      )}
    </>
  );
};

export default HemathologyOrder;
